import styled from 'styled-components'

export const CountryWrap = styled.li`
  display: flex;
  gap: 1rem;
  padding: 1rem 0;
  align-items: center;

  a {
    display: block;
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: ${({ theme }) => theme.fonts.brand};

    font-size: 1.4rem;
    line-height: 1.25;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const CountryFlag = styled.div`
  width 1.4rem;
  height: 1.2rem;
`
